import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
 
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { AuthenticationInterceptorInterceptor } from './interceptor/authentication-interceptor.interceptor';
import { DataExportComponent } from './components/data-export/data-export.component';
import { DataExportSuccessComponent } from './components/data-export-success/data-export-success.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ControllerInventorySuccessComponent } from './components/controller-inventory-success/controller-inventory-success.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
 
import { environment } from '../environments/environment';
import { DeleteAccountRequestComponent } from './components/delete-account-request/delete-account-request.component';
import { DeleteRequestSuccessComponent } from './components/delete-request-success/delete-request-success.component';
import { DeleteAccountComponent } from './components/delete-account/delete-account.component';
import { DeleteAccountSucessComponent } from './components/delete-account-sucess/delete-account-sucess.component';
import { NgxGaugeModule } from 'ngx-gauge';
 
import { CommonService } from './services/common/common.service';
import { WebService } from './services/web/web.service';
import { AppSessionStorageService } from './services/utils/session-storage.service';
import { TwoFactorAuthenticateComponent } from './components/two-factor-authenticate/two-factor-authenticate.component';
import { NumberInputDirective } from './directives/number-input.directive';
import { ProfileEditComponent } from './components/profile-edit/profile-edit.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { RestrictedAccessComponent } from './components/restricted-access/restricted-access.component';
import { AccountCreateSuccessComponent } from './components/account-create-success/account-create-success.component';
import { UserExistComponent } from './components/user-exist/user-exist.component';
 
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NotfoundComponent,
    DataExportComponent,
    DataExportSuccessComponent,
    ErrorPageComponent,
    ControllerInventorySuccessComponent,
    DeleteAccountRequestComponent,
    DeleteRequestSuccessComponent,
    DeleteAccountComponent,
    DeleteAccountSucessComponent,
    TwoFactorAuthenticateComponent,
    NumberInputDirective,
    ProfileEditComponent,
    ChangePasswordComponent,
    CreateAccountComponent,
    RestrictedAccessComponent,
    AccountCreateSuccessComponent,
    UserExistComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    HttpClientModule,
    NgxCaptchaModule,
    RecaptchaV3Module,
    NgxGaugeModule,
    SideBarComponent,
    NgSelectModule,
 
  ],
  providers: [
    WebService,
    AppSessionStorageService,
    CommonService,{provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptorInterceptor, multi:true},
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.siteKey,
    },],
  bootstrap: [AppComponent]
})
export class AppModule { }
 
 